import { unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1f9c37e6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "honor-poster-container"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = ["onClick"];
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "action-divider"
}, null, -1));
const _hoisted_5 = ["onClick"];
import { ref, onMounted, onUnmounted } from 'vue';
import env from "md-base-tools/env";
export default {
  props: {
    imageUrl: {
      type: String,
      required: true
    }
  },
  emits: ['close', 'download', 'share'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const isFix = ref(false);
    const statusBarH = ref(10);
    const safeAreaBottom = ref(20); // 底部安全区域高度
    const scrollWrapper = ref(null);
    const posterImage = ref(null);
    const handleImageClick = () => {
      emit('close');
    };
    const handleClose = () => {
      emit('close');
    };
    const handleDownload = () => {
      emit('download', props.imageUrl);
    };
    const handleShare = () => {
      emit('share', props.imageUrl);
    };
    const handleImageLoad = () => {
      // 图片加载完成后，先显示图片，然后判断布局
      if (posterImage.value) {
        posterImage.value.classList.add('loaded');
      }

      // 立即判断是否需要调整布局
      checkImageCentering();
    };
    const checkImageCentering = () => {
      if (!scrollWrapper.value || !posterImage.value) return;
      const wrapper = scrollWrapper.value;
      const image = posterImage.value;
      if (image.complete) {
        const wrapperHeight = wrapper.clientHeight;
        const wrapperWidth = wrapper.clientWidth;

        // 计算图片按屏幕宽度缩放后的高度
        const imageNaturalWidth = image.naturalWidth;
        const imageNaturalHeight = image.naturalHeight;
        const scaledImageHeight = imageNaturalHeight * Math.min(wrapperWidth, 750) / imageNaturalWidth;

        // 如果缩放后的图片高度大于容器高度，则需要滚动查看
        if (scaledImageHeight > wrapperHeight) {
          wrapper.classList.add('scrollable-image');
        } else {
          wrapper.classList.remove('scrollable-image');
        }
      }
    };
    onMounted(() => {
      // 锁定背景滚动
      document.body.style.overflow = 'hidden';

      // 如果是APP端，获取设备信息
      if (env.isModianIos() || env.isModianAndroid()) {
        // eslint-disable-next-line no-undef
        graft.app({
          functionName: "onGetDeviceInfo",
          functionParams: {},
          callBack: e => {
            statusBarH.value = e.data.statusBarH || 10;
            safeAreaBottom.value = e.data.safeAreaBottom || 20;
          }
        });
      }
    });

    // 组件卸载时恢复背景滚动
    onUnmounted(() => {
      document.body.style.overflow = 'auto';
    });
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("header", {
        class: _normalizeClass([{
          'headerAndroid': _unref(env).isModianAndroid()
        }]),
        style: _normalizeStyle({
          'padding-top': statusBarH.value + 'px'
        })
      }, [_unref(env).isModianIos() || _unref(env).isModianIosNew() || _unref(env).isModianAndroid() ? (_openBlock(), _createBlock(_component_van_image, {
        key: 0,
        class: _normalizeClass(["back-icon", {
          'isFix': isFix.value
        }]),
        "lazy-load": "",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/project_honor_nav_back.png', 40),
        onClick: _withModifiers(handleClose, ["stop"])
      }, null, 8, ["class", "src", "onClick"])) : _createCommentVNode("", true)], 6), _createElementVNode("div", {
        class: "image-container",
        onClick: handleImageClick
      }, [_createElementVNode("div", {
        class: "image-scroll-wrapper",
        ref_key: "scrollWrapper",
        ref: scrollWrapper
      }, [_createElementVNode("img", {
        class: "poster-image",
        src: _ctx.$imgUrlFilter(__props.imageUrl, 750),
        onLoad: handleImageLoad,
        ref_key: "posterImage",
        ref: posterImage
      }, null, 40, _hoisted_2)], 512)]), _createElementVNode("div", {
        class: _normalizeClass(["bottom-actions", {
          'has-share': _unref(env).isModianIos() || _unref(env).isModianAndroid()
        }]),
        style: _normalizeStyle({
          'padding-bottom': safeAreaBottom.value + 'px'
        })
      }, [_createElementVNode("div", {
        class: "action-btn download-btn",
        onClick: _withModifiers(handleDownload, ["stop"])
      }, [_createVNode(_component_van_image, {
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/honor_download_icon.png', 48)
      }, null, 8, ["src"])], 8, _hoisted_3), _unref(env).isModianIos() || _unref(env).isModianAndroid() ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_hoisted_4, _createElementVNode("div", {
        class: "action-btn share-btn",
        onClick: _withModifiers(handleShare, ["stop"])
      }, [_createVNode(_component_van_image, {
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/honor_share_white_icon.png', 48)
      }, null, 8, ["src"])], 8, _hoisted_5)], 64)) : _createCommentVNode("", true)], 6)]);
    };
  }
};